import { ListItem, ListView } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { useFetchCompanyInstantPaymentLimits } from 'src/core/modules/company/hooks';

import { AmountLimitSection } from './AmountLimitSection';
import { DailyLimitSection } from './DailyLimitSection';

export const InstantPaymentLimits = () => {
  const { t } = useTranslation('global');

  const { isLoading: isFetchingInstantPaymentLimits, isAmountLimitEnabled } =
    useFetchCompanyInstantPaymentLimits();

  return (
    <section
      aria-labelledby="instantPaymentLimits"
      className="GeneralSettingsPage__section"
    >
      <h1 id="instantPaymentLimits" className="text-content-primary heading-l">
        {t('generalSettings.instantPaymentLimits.title')}
      </h1>
      <p className="text-content-secondary-bg-primary body-m mt-8">
        {t('generalSettings.instantPaymentLimits.description')}
      </p>
      <ListView className="mt-24">
        <ListItem>
          <AmountLimitSection />
        </ListItem>
        {isAmountLimitEnabled && !isFetchingInstantPaymentLimits ? (
          <ListItem>
            <DailyLimitSection />
          </ListItem>
        ) : null}
      </ListView>
    </section>
  );
};
